import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MicrosoftTeamsUserResult } from '../../../shared/models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class MicrosoftTeamsUserSearchResource {
  private http = inject(HttpClient);

  search(
    tenantId: string,
    query: string,
    enterpriseVoiceEnabled?: boolean,
    limit = 250,
    accountType = 'ALL',
  ): Observable<MicrosoftTeamsUserResult[]> {
    let params = `q=${encodeURIComponent(query)}&accountType=${accountType}`;
    if (limit != null) {
      params += `&limit=${limit}`;
    }
    if (enterpriseVoiceEnabled != null) {
      params += `&enterpriseVoiceEnabled=${enterpriseVoiceEnabled}`;
    }
    return this.http.get<MicrosoftTeamsUserResult[]>(
      `/services/microsoft/macs/tenants/${tenantId}/teams-users/search?${params}`,
    );
  }
}
